import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from "react-router-dom";
import ElectricServices from "../images/Electrical  Services.jpg";

import electricboard from "../images/BOARD.jpg";
import voltelectric240 from "../images/Palfrey 240 Volts Electric Extension Board - 16A.jpg";
import pin25mitreextentionboard from "../images/2 Pin 5 Metre Extension Board With Indicator and Handle.jpg";
import orientelectric from "../images/Orient Electric 12W High Glow LED bulb.jpg";
import HoteonExtensionBoard5Meter from "../images/Hoteon Extension Board 5 Meter.jpg";


function Electricservices() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <div className="cctvfotageberhampore">
        <div className="album py-1">

          <div className="container mt-4">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Electric Services</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className='computershopberhampore'>
        <br />
        <div className="album py-1">

          <div className="container">
            <div className="row">
              <div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={electricboard} className="card-img-top" alt="electricboard"/>
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>Electric Board</b></h5>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={voltelectric240} className="card-img-top" alt="voltelectric240"/>
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>240 Volt Electric</b></h5>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={pin25mitreextentionboard} className="card-img-top" alt="pin25mitreextentionboard" />
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>2 Metre Extention Board</b></h5>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={orientelectric} className="card-img-top" alt="orientelectric"/>
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>Orient Electric</b></h5>
                  </div>
                </div>
              </div>

    <div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={HoteonExtensionBoard5Meter} className="card-img-top" alt="HoteonExtensionBoard5Meter"/>
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>Hoteon Extension Board 5Meter</b></h5>
                  </div>
                </div>
              </div>

                
                 
              
              
            </div>
          </div>
        </div>
        <br />
        <br />
      </div>
      <br />
      <div className="album py-1">

        <div className="container ">
          <div className="row">

            <div className="col-md-8">
              <h1 style={{color:"#030D54"}}>Electrical Service <b>Government Office</b></h1>
              <hr />
              <p className='justify'>We offer trusted Electrical Services for Government Offices, ensuring high-standard, compliant, and secure installations. Our services include official wiring, panel board setup, lighting systems, UPS & power backup solutions, and regular maintenance, all delivered with precision, safety, and reliability.</p>
              <br />
              <h1 style={{color:"#030D54"}}>Electrical Service <b>Corporate Office</b></h1>
              <hr />
              <p className='justify'>Our Corporate Electrical Service delivers safe, efficient, and professional solutions tailored for modern workplaces. We handle complete office wiring, lighting installation, network & power points, UPS and power backup setup, maintenance, and electrical fault repair to ensure smooth, uninterrupted operations with top-level safety and reliability.</p>
              <br/>
   <h1 style={{color:"#030D54"}}>Electrical Service <b>House Use</b></h1>
              <hr />
              <p className='justify'>Our Home Electrical Service provides safe, reliable, and professional solutions for all household needs. From wiring & rewiring, switchboard installation, LED/light fitting, fan/AC/geyser setup, to fault repair, we ensure quick and secure service for a trouble-free home.</p>
               <a className='mb-3' href='tel: 9064797437'>Help Line No. 9064797437</a>
               <br/>
               <br/>
            </div>
            <div className="col-md-4">
                    <img src={ElectricServices} className="d-block w-100" alt="Electric Services"/>

            </div>
          
          </div>

        </div>
      </div>

  <br/>

  

    </div>
  )
}

export default Electricservices